import { render, staticRenderFns } from "./memberPwd.vue?vue&type=template&id=7cf0db9a&scoped=true&"
import script from "./memberPwd.vue?vue&type=script&lang=js&"
export * from "./memberPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf0db9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cf0db9a')) {
      api.createRecord('7cf0db9a', component.options)
    } else {
      api.reload('7cf0db9a', component.options)
    }
    module.hot.accept("./memberPwd.vue?vue&type=template&id=7cf0db9a&scoped=true&", function () {
      api.rerender('7cf0db9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberManage/memberPwd.vue"
export default component.exports